var FileConverterService_1;
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { from, map, mergeMap, Observable, toArray } from 'rxjs';
import { ConstructorName } from '../decorators';
import * as i0 from "@angular/core";
import * as i1 from "./monitoring.service";
let FileConverterService = class FileConverterService {
  static {
    FileConverterService_1 = this;
  }
  monitoringService;
  constructor(monitoringService) {
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', FileConverterService_1), 'constructor');
  }
  convertToBinaryFiles(files) {
    return from(files).pipe(mergeMap(file => this.convertToBinaryFile(file)), toArray());
  }
  convertToBinaryFile(file) {
    return this.getBase64StringFromFile(file).pipe(map(binary => ({
      name: file?.name || '',
      binary
    })));
  }
  getBase64StringFromFile(file) {
    return new Observable(observer => {
      const reader = new FileReader();
      const loadHandler = () => {
        observer.next(String(reader.result).split(',')[1]);
        observer.complete();
      };
      const errorHandler = error => {
        observer.error(error);
      };
      reader.onload = loadHandler;
      reader.onerror = errorHandler;
      reader.readAsDataURL(file);
      return () => {
        reader.abort();
      };
    });
  }
  static ɵfac = function FileConverterService_Factory(t) {
    return new (t || FileConverterService)(i0.ɵɵinject(i1.MonitoringService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FileConverterService,
    factory: FileConverterService.ɵfac,
    providedIn: 'root'
  });
};
FileConverterService = FileConverterService_1 = __decorate([ConstructorName('FileConverterService')], FileConverterService);
export { FileConverterService };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileConverterService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.MonitoringService
  }], null);
})();
